module.exports = __webpack_public_path__ + "static/media/formats-layout-icon.956d3f8d.svg";